import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ApiAccessSection } from './apiAccess/ApiAccessSection';

const BUSINESS_EMAIL = 'business@music24.com';

/**
 * Settings → API. The whole tab is the API-access surface now: the section owns
 * its own heading and the link to the hosted reference.
 */
const ApiTabComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div>
      <ApiAccessSection />
      <p className="text-muted small mt-4 mb-0">
        {intl.formatMessage(
          {
            id: 'app.sml.settings.api.business',
            defaultMessage:
              'Need higher limits, custom endpoints, or a private licensing arrangement? Contact us at {email}.',
          },
          {
            email: <a href={`mailto:${BUSINESS_EMAIL}`}>{BUSINESS_EMAIL}</a>,
          }
        )}
      </p>
    </div>
  );
};

export const ApiTab = TypedMemo(ApiTabComponent);
